export default __webpack_public_path__ + "static/media/9.6b5d311c.svg";